// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import chapterEvidenceEntity from './entities/chapter-evidence.json';
import chapterEvidenceMenu from '../pages/chapter-evidence/menu.json';
import chapterEvidenceFullForm from '../pages/chapter-evidence/forms/full.json';
import chapterEvidenceContextForm from '../pages/chapter-evidence/forms/context.json';
import chapterEvidenceMiniForm from '../pages/chapter-evidence/forms/mini.json';
import chapterEvidenceLookupForm from '../pages/chapter-evidence/forms/lookup.json';
import chapterEvidenceTableView from '../pages/chapter-evidence/views/table.json';
import chapterEvidenceCardsView from '../pages/chapter-evidence/views/cards.json';
import chapterEvidenceDashboardView from '../pages/chapter-evidence/views/dashboard.json';

/** Тип запису «Підтвердження» зі сторінками пакета: меню, форми та подання з pages/chapter-evidence/. */
export const chapterEvidenceDefinition: IRecordTypeDefinition = {
  ...chapterEvidenceEntity,
  views: assembleViewSet({
      table: chapterEvidenceTableView,
      cards: chapterEvidenceCardsView,
      dashboard: chapterEvidenceDashboardView,
  }),
  form: chapterEvidenceFullForm,
  forms: { full: chapterEvidenceFullForm, context: chapterEvidenceContextForm, mini: chapterEvidenceMiniForm, lookup: chapterEvidenceLookupForm },
  menu: chapterEvidenceMenu,
} as IRecordTypeDefinition;
